module.exports = "<div class=content _v-f565fa20=\"\"> <h1 class=question _v-f565fa20=\"\">{{ question.title }}</h1> <li class=option :class=\"{'checked': selectedItem==item}\" v-for=\"item in question.options\" @click=select(item,$event) _v-f565fa20=\"\"> {{ item.text }} </li> <div class=next-btn :class=\"{'disable':btnDisable}\" @click=goNext _v-f565fa20=\"\"><span v-if=complete _v-f565fa20=\"\">完成</span><span v-if=!complete _v-f565fa20=\"\">下一题</span></div> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-f565fa20!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/radioList.vue
 ** module id = 75
 ** module chunks = 1
 **/